import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Select from 'react-select';
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import axios from 'axios';
import { baseAPI } from '../../services/baseAPI';

function TambahAnggota() {
  const { id, npp } = useParams();
  const history = useHistory();
  const ADMIN = 1;
  const ANGGOTA = 2;
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);
  const [newData, setNewData] = useState([{
    name: "",
    npp: "",
    idkopkar:"",
    stat_kopkar:"",
    stat_spn:"",
    role:"",
    email:"",
  }]);
  const [listStatusKopkar, setListStatusKopkar] = useState([
    { label: "1 - Aktif", value: 1 },
    { label: "0 - Tidak Aktif", value: 0 },
  ]);
  const [listStatusSPN, setListStatusSPN] = useState([
    { label: "1 - Aktif", value: 1 },
    { label: "0 - Tidak Aktif", value: 0 },
  ]);
  const [listRole, setListRole] = useState([]);
  const [maxId, setMaxId] = useState();
  const [maxIdKopkar, setMaxIdKopkar] = useState();


  // CONTROLLER
  const fetchDataAnggota = async () => {

    await axios
      .all(
        [
         baseAPI .get(`/v1/user`, {headers: { Authorization: `Bearer ${token}` } }),
         baseAPI .get(`/v1/role`, {headers: { Authorization: `Bearer ${token}` } }),
      ]
      )
      .then((res) => {
        const maxId       = res[0].data.data.maxId;
        const maxIdKopkar = res[0].data.data.maxIdKopkar;
        const dataRole    = res[1].data.data;

        let roles = [];
        dataRole.forEach(e => {
          roles.push({ label: e.id + " - " + e.role_name, value: e.id })
        });
        
        let number = parseInt((maxIdKopkar[0].idKopkarMax).slice(-4), 10);

        setListRole(roles);
        setMaxId(maxId[0].idMax + 1);
        setMaxIdKopkar(number + 1);
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
  };

  const storeNewUser = async () => {
    
    Swal.fire({
      title: 'Do you want to save the data?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Save',
      denyButtonText: `Don't save`,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const body = new FormData();
        body.append('new_data', JSON.stringify(newData));
        
        baseAPI
          .post(`/v1/user`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "New user has been added.",
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`berhasil upload ${JSON.stringify(res)}`);
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Failed add new user.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
            fetchDataAnggota();
          })
      } else if (result.isDenied) {
        Swal.fire('New user is not added', '', 'info')
      }
    });

  }

  useEffect(() => {
    if (user.role === ADMIN) {
      fetchDataAnggota();
    };
  }, [token]);
  

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Anggota</Link> /{' '}
              <Link to='/anggota/tambahanggota' style={{ color: '#333' }}>Tambah Anggota</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Tambah Pengguna Baru</b></p>
              </div>

              {/* Username/NPP */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  NPP
                </label>
                <input
                  placeholder='NPP untuk username anda'
                  className="form-control"
                  onChange={e => setNewData([{...newData[0], npp: e.target.value}])}
                />
              </div>

              {/* Name */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Nama
                </label>
                <input
                  placeholder='Nama anda'
                  className="form-control"
                  onChange={e => setNewData([{...newData[0], name: e.target.value}])}
                />
              </div>

              {/* ID Kopkar */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  ID Kopkar
                </label>
                <input
                  readOnly
                  value={"KKAB" + String(maxIdKopkar).padStart(4, '0')}
                  placeholder='ID Kopkar'
                  className="form-control"
                  onChange={e => setNewData([{...newData[0], idkopkar: "KKAB" + String(maxIdKopkar).padStart(4, '0')}])}
                />
              </div>

              {/* Email */}
              <div className='col-md-12 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Email
                </label>
                <input
                  placeholder='Email anda'
                  className="form-control"
                  onChange={e => setNewData([{...newData[0], email: e.target.value}])}
                />
              </div>

              {/* Status Anggota Kopkar */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Status Anggota Kopkar
                </label>
                <Select
                  options={listStatusKopkar}
                  defaultValue={listStatusKopkar && newData[0].stat_kopkar}
                  placeholder="Pilih status"
                  onChange={e => {
                    setNewData([{...newData[0], stat_kopkar: e.value}])
                  }}
                />
              </div>

              {/* Status Anggota SPN */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Status Anggota SPN
                </label>
                <Select
                  options={listStatusSPN}
                  defaultValue={listStatusSPN && newData[0].stat_spn}
                  placeholder="Pilih status"
                  onChange={e => {
                    setNewData([{...newData[0], stat_spn: e.value}])
                  }}
                />
              </div>

              {/* Role Anggota */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Role Anggota
                </label>
                <Select
                  options={listRole}
                  defaultValue={listRole && newData[0].role}
                  placeholder="Pilih role anggota"
                  onChange={e => {
                    setNewData([{...newData[0], role: e.value}])
                  }}
                />
              </div>

              <div className='col-md-12'>
                <button
                  // disabled={newData[0].event !== "" && newData[0].item !== "" && newData[0].amount !== "" && newData[0].event_date !== "" && newData[0].name !== "" && newData[0].npp !== "" && newData[0].department !== "" ? false : true}
                  type="button"
                  className='btn btn-danger col-md-12'
                  style={{backgroundColor: '#CD5C08'}}
                  onClick={() => storeNewUser()}
                >
                  Tambah
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default TambahAnggota;